import React from 'react';
import { Package, Brain, Zap, TrendingUp, BookOpen } from 'lucide-react';
export function ProductContents() {
  return <section className="py-12 bg-navy-900" data-id="element-172">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-173">
        {/* Lo que vas a recibir */}
        <div className="mb-12" data-id="element-174">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-6 flex items-center gap-3" data-id="element-175">
            <Package className="w-7 h-7 text-gold-400" data-id="element-176" />
            Lo que vas a recibir
          </h2>
          <div className="bg-navy-800 rounded-xl p-6 border border-navy-700" data-id="element-177">
            <p className="text-base text-slate-300 mb-4" data-id="element-178">
              Dentro de Charter Command System™ vas a encontrar:
            </p>
            <div className="grid sm:grid-cols-2 gap-3 mb-4" data-id="element-179">
              <div className="flex items-center gap-2 text-white bg-navy-900 p-3 rounded-lg text-sm" data-id="element-180">
                <span className="text-green-400 font-bold" data-id="element-181">✔</span> Checklists
                listos para usar
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-3 rounded-lg text-sm" data-id="element-182">
                <span className="text-green-400 font-bold" data-id="element-183">✔</span> Plantillas
                profesionales
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-3 rounded-lg text-sm" data-id="element-184">
                <span className="text-green-400 font-bold" data-id="element-185">✔</span> Scripts de
                comunicación claros
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-3 rounded-lg text-sm" data-id="element-186">
                <span className="text-green-400 font-bold" data-id="element-187">✔</span> Sistema de
                control diario
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-3 rounded-lg text-sm sm:col-span-2" data-id="element-188">
                <span className="text-green-400 font-bold" data-id="element-189">✔</span> Estructura
                completa de operación
              </div>
            </div>
            <p className="text-center text-gold-400 font-medium text-base" data-id="element-190">
              Todo diseñado para que no tengas que inventar nada.
            </p>
          </div>
        </div>

        {/* Resultados en 7 días */}
        <div className="mb-12" data-id="element-191">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-6 flex items-center gap-3" data-id="element-192">
            <Zap className="w-7 h-7 text-gold-400" data-id="element-193" />
            Lo que podés lograr en menos de 7 días
          </h2>
          <div className="bg-gradient-to-br from-navy-800 to-navy-900 p-6 rounded-xl border border-navy-700" data-id="element-194">
            <p className="text-base text-slate-300 mb-4" data-id="element-195">
              En menos de una semana podés:
            </p>
            <ul className="space-y-2 mb-6" data-id="element-196">
              <li className="flex items-center gap-2 text-white" data-id="element-197">
                <div className="w-2 h-2 bg-gold-500 rounded-full" data-id="element-198"></div> Ordenar
                completamente tu operación
              </li>
              <li className="flex items-center gap-2 text-white" data-id="element-199">
                <div className="w-2 h-2 bg-gold-500 rounded-full" data-id="element-200"></div> Reducir
                errores drásticamente
              </li>
              <li className="flex items-center gap-2 text-white" data-id="element-201">
                <div className="w-2 h-2 bg-gold-500 rounded-full" data-id="element-202"></div> Mejorar
                la coordinación del equipo
              </li>
              <li className="flex items-center gap-2 text-white" data-id="element-203">
                <div className="w-2 h-2 bg-gold-500 rounded-full" data-id="element-204"></div> Tener
                control real sin estar encima de todo
              </li>
              <li className="flex items-center gap-2 text-white" data-id="element-205">
                <div className="w-2 h-2 bg-gold-500 rounded-full" data-id="element-206"></div> Elevar
                la experiencia del cliente
              </li>
            </ul>
            <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-207">
              <span className="bg-navy-950 px-3 py-1.5 rounded-lg text-slate-300 text-center text-xs font-medium" data-id="element-208">
                👉 Sin cambiar tu tripulación
              </span>
              <span className="bg-navy-950 px-3 py-1.5 rounded-lg text-slate-300 text-center text-xs font-medium" data-id="element-209">
                👉 Sin trabajar más
              </span>
              <span className="bg-navy-950 px-3 py-1.5 rounded-lg text-slate-300 text-center text-xs font-medium" data-id="element-210">
                👉 Sin depender de la improvisación
              </span>
            </div>
          </div>
        </div>

        {/* Resultados a largo plazo */}
        <div className="mb-12" data-id="element-211">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-6 flex items-center gap-3" data-id="element-212">
            <TrendingUp className="w-7 h-7 text-gold-400" data-id="element-213" />
            Resultados que vas a empezar a notar
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 mb-6" data-id="element-214">
            {['Menos problemas diarios', 'Más claridad en cada rol', 'Mejor ambiente a bordo', 'Mayor profesionalismo', 'Clientes más satisfechos', 'Más tranquilidad para vos'].map((res, i) => <div key={i} className="bg-navy-800 p-3 rounded-xl border border-navy-700 text-center text-slate-200 text-sm" data-id="element-215">
                {res}
              </div>)}
          </div>
          <div className="text-center bg-gold-500/10 border border-gold-500/30 p-4 rounded-xl" data-id="element-216">
            <p className="text-slate-300 mb-1 text-sm" data-id="element-217">Y el más importante:</p>
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-218">
              👉 Dejar de sobrevivir… y empezar a dirigir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}